import axios from './http'
import de from "element-ui/src/locale/lang/de";

/**
 * 跟轮数相关的
 * @type {{getGameRule(): Promise<AxiosResponse<any>>, updateGameRule(*=): Promise<AxiosResponse<*>>}}
 */
const gameRule = {

  /**
   * 得到轮数
   */
  getGameRule() {
    return axios.get('/thesis/gameRule')
  },

  /**
   * 修改轮数
   * @param gameRule
   * @returns {Promise<AxiosResponse<any>>}
   */
  updateGameRule(gameRule) {
    return axios.put('/thesis/gameRule', gameRule)
  },

}

export default gameRule



// WEBPACK FOOTER //
// ./src/api/gameRule.js